<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<span class="signature-purpose" *ngIf="toDisplay">
    <i class="fa fa-info-circle"></i>
    <a id="global-consent-link" (click)="displayGlobalConsent()">{{'signatureProcessDetails.displayedLink' | translate}}</a>
</span>
